import { Button } from "@circleco/compass/components/Button";

import { t } from "@/i18n-js/instance";

interface LinkPopoverFooterProps {
  formId: string;
  isEditingExistingLink: boolean;
  onCancel: () => void;
  onRemove: () => void;
}

export const LinkPopoverFooter = ({
  formId,
  isEditingExistingLink,
  onCancel,
  onRemove,
}: LinkPopoverFooterProps) => (
  <div className="flex items-center justify-between gap-2">
    <div>
      {isEditingExistingLink && (
        <Button variant="outline" size="sm" onClick={onRemove} type="button">
          {t("tiptap.extensions.link.remove")}
        </Button>
      )}
    </div>
    <div className="flex items-center gap-2">
      <Button variant="secondary" size="sm" type="button" onClick={onCancel}>
        {t("cancel")}
      </Button>
      <Button variant="primary" size="sm" type="submit" form={formId}>
        {t("tiptap.extensions.link.save")}
      </Button>
    </div>
  </div>
);
